import * as Headless from '@headlessui/react';
import { Link as TanStackLink, type LinkComponentProps } from '@tanstack/react-router';
import React, { forwardRef } from 'react';

export type LinkProps = (
  | ({ href?: never } & LinkComponentProps)
  | ({ href: string; to?: never })
) & Omit<React.ComponentPropsWithoutRef<'a'>, 'href'>;

export const Link = forwardRef(function Link(
  props: LinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  const { ...rest } = props;

  return 'href' in props ?
      (
        <Headless.DataInteractive>
          <a {...rest} ref={ref} />
        </Headless.DataInteractive>
      ) :
      (
        <Headless.DataInteractive>
          <TanStackLink {...rest} ref={ref} />
        </Headless.DataInteractive>
      );
});
